import React, { useState, useEffect } from "react";
import { db, auth } from "../firebaseConfig";
import { doc, updateDoc, getDoc, setDoc } from "firebase/firestore";
import { useAuthState } from "react-firebase-hooks/auth";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import ProgressBar from "../components/ProgressBar";
import "../styles/CompleteProfile.css";

const CompleteProfileHope = () => {
  const [user] = useAuthState(auth);
  const [profile, setProfile] = useState({ hope: "" });
  const [error, setError] = useState("");
  const [emailVerified, setEmailVerified] = useState(false);
  const navigate = useNavigate();

  const hopeOptions = [
    { value: "こだわらない", label: "こだわらない" },
    { value: "日中", label: "日中" },
    { value: "パブリックな場所", label: "パブリックな場所" },
    { value: "日中+パブリックな場所", label: "日中+パブリックな場所" },
    { value: "その他", label: "その他" }
  ];

  useEffect(() => {
    if (user) {
      user.reload().then(() => {
        setEmailVerified(user.emailVerified);
      });

      const fetchProfile = async () => {
        try {
          const docRef = doc(db, "members", user.uid);
          const docSnap = await getDoc(docRef);
          if (docSnap.exists()) {
            setProfile({ hope: docSnap.data().hope || "" });
          }
        } catch (error) {
          console.error("Error fetching profile:", error.message);
          setError("プロフィールの取得中にエラーが発生しました。");
        }
      };
      fetchProfile();
    }
  }, [user]);

  const handleSave = async () => {
    if (!emailVerified) {
      setError("メールアドレスの認証が完了していません。メールを確認してください。");
      return;
    }

    try {
      const userDocRef = doc(db, "members", user.uid);
      await setDoc(userDocRef, { hope: profile.hope || "" }, { merge: true });
      await updateDoc(userDocRef, { onboardingCompleted: true });
      navigate("/member_search");
    } catch (error) {
      console.error("Error saving profile:", error.message);
      setError("プロフィールの保存中にエラーが発生しました。");
    }
  };

  return (
    <div className="complete-profile-container">
      <ProgressBar step={2} totalSteps={3} />
      <h2>会う時の希望</h2>
      {error && <p className="error-message">{error}</p>}

      {emailVerified ? (
        <div className="form-group-a">
          <label>会う時の希望:</label>
          <Select
            name="hope"
            isSearchable={false}
            value={profile.hope ? { value: profile.hope, label: profile.hope } : null}
            onChange={(option) => setProfile({ hope: option.value })}
            options={hopeOptions}
            className="select-box"
            placeholder="選択してください"
          />
        </div>
      ) : (
        <p>メールアドレスの認証が完了していません。メールを確認してください。</p>
      )}

      <button onClick={handleSave} className="complete-profile-button">完了</button>
    </div>
  );
};

export default CompleteProfileHope;
